import { render, staticRenderFns } from "./TitleFrame.vue?vue&type=template&id=10100332&"
import script from "./TitleFrame.vue?vue&type=script&lang=js&"
export * from "./TitleFrame.vue?vue&type=script&lang=js&"
import style0 from "./TitleFrame.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports